import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { sidebarProjectActionsMenuItemSelectedEvent, sidebarProjectActionsMenuOpenedEvent, } from '#pplx/frontend/apps/ask/events/sidebar/analytics.js';
import { usePinUserSpace } from '#pplx/frontend/apps/ask/hooks/collections-hooks/usePinUserSpace.js';
import { useUnpinUserSpace } from '#pplx/frontend/apps/ask/hooks/collections-hooks/useUnpinUserSpace.js';
import { getSpaceMenuActionPermissions } from '#pplx/frontend/apps/ask/spaces-redesign/getSpaceMenuActionPermissions.js';
import { deleteProjectWithConfirmation, leaveProjectWithConfirmation, } from '#pplx/frontend/apps/ask/spaces-redesign/projectModalActions.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
const UNAVAILABLE = { kind: 'unavailable' };
export function useSidebarProjectInteractionsFactory() {
    const { mutate: pin } = usePinUserSpace({ reason: 'sidebar-v3-project-actions' });
    const { mutate: unpin } = useUnpinUserSpace({ reason: 'sidebar-v3-project-actions' });
    const { track } = useInstrumentation();
    const { openModal } = useModalContext();
    const { session } = useSession();
    const userEmail = session?.user?.email;
    return useCallback(({ project, pinned }) => {
        const select = (action, run) => () => {
            track(sidebarProjectActionsMenuItemSelectedEvent({
                name: 'sidebar project actions menu item selected',
                data: { action, collectionUUID: project.uuid },
            }));
            run();
        };
        const [canLeave, isOwner] = getSpaceMenuActionPermissions(project);
        return {
            pinToggle: pinned
                ? { kind: 'unpin', onSelect: select('unpin', () => unpin(project)) }
                : { kind: 'pin', onSelect: select('pin', () => pin(project)) },
            leave: canLeave
                ? {
                    kind: 'available',
                    onSelect: select('leave', () => {
                        void leaveProjectWithConfirmation({ openModal, project, userEmail });
                    }),
                }
                : UNAVAILABLE,
            delete: isOwner
                ? {
                    kind: 'available',
                    onSelect: select('delete', () => {
                        void deleteProjectWithConfirmation({ openModal, project });
                    }),
                }
                : UNAVAILABLE,
            trackMenuOpened: () => {
                track(sidebarProjectActionsMenuOpenedEvent({
                    name: 'sidebar project actions menu opened',
                    data: { collectionUUID: project.uuid },
                }));
            },
        };
    }, [openModal, pin, track, unpin, userEmail]);
}
//# sourceMappingURL=useSidebarProjectInteractions.js.map